/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BulkJobParameters } from './bulkJobParameters';
import type { RunBulkJobRequestLabel } from './runBulkJobRequestLabel';

/**
 * Request model for bulk job
 */
export interface RunBulkJobRequest {
  type: 'bulk';
  params: BulkJobParameters;
  label?: RunBulkJobRequestLabel;
  allowOverlappingJobs?: boolean;
}
